module.exports = "/build/admin/images/apple-touch-icon-144x144.804f329e.png";